module.exports = __webpack_public_path__ + "static/img/geotap-game-mobile-unlockable-low-poly-shapes.16ed5dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/geotap-game-mobile-unlockable-low-poly-shapes.png
// module id = Nb4G
// module chunks = 0